(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-prolong.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-prolong.js'); 
'use strict';

svs.maltipset.views.BetslipProlong = Backbone.Marionette.View.extend({
  template: function(data) {
    return svs.maltipset.templates.betslip_prolong(data);
  },
  regions: {
    weekSelector: '.flying-week-selector'
  },

  onAttach: function() {
    this.getRegion('weekSelector').show(
      new svs.maltipset.views.BetslipContentWeeks({
        model: new svs.maltipset.models.Betslip({
          coupon: this.options.coupon
        })
      })
    );
  }
});

 })(window);